module.exports = __webpack_public_path__ + "static/img/rb.ccc1bb3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/lang/rb.png
// module id = O0FT
// module chunks = 1